import { Form, FormItem } from 'sutra/components/Form'
import { Input } from 'sutra/components/Input/Input'
import { PopoverModal } from 'sutra/components/PopoverModal/PopoverModal'

export type CreateAccountGroupModalProps = {
  open: boolean
  name: string
  isCreating: boolean
  errorMessage: string | null
  onNameChange: (name: string) => void
  onCreate: () => void
  onClose: () => void
}

export const CreateAccountGroupModal = ({
  open,
  name,
  isCreating,
  errorMessage,
  onNameChange,
  onCreate,
  onClose,
}: CreateAccountGroupModalProps): JSX.Element => (
  <PopoverModal
    title="Create account group"
    isOpen={open}
    onOk={onCreate}
    onClose={onClose}
    okText="Create group"
    okButtonProps={{ loading: isCreating }}
    width={520}
    content={
      <Form layout="vertical">
        <FormItem
          label="Name"
          required
          validateStatus={errorMessage ? 'error' : ''}
          help={errorMessage}
        >
          <Input
            name="name"
            $error={!!errorMessage}
            placeholder="Account group name"
            value={name}
            onChange={(event) => onNameChange(event.target.value)}
          />
        </FormItem>
      </Form>
    }
  />
)
